export const normalizeNotification = notification => ({
    id: notification.id,
    message: notification.message,
    createdAt: notification.created_at,
    read: notification.seen,
    type: notification.type,
    url: notification.url,
    payload: notification.payload,
})

export const normalizeFetchNotificationsResponse = response => ({
    notifications: response.notifications.map(normalizeNotification),
    totalPages: response.total_pages,
    totalUnread: response.total_unread_notifications,
})
